import axios, { AxiosError } from 'axios'
import config from 'config'
import { ReturnCustomerSelectionsType } from 'containers/ReturnCustomer/types/returnCustomerTypes'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import {
    SelectedExtendedWarranty,
    SelectedTireAndWheel,
} from './interfaces/ClientApplication'
import { SubmitApplicationDTO } from './postApplication'

export interface UpdateClientApplication {
    home_phone?: string
    mobile_phone?: string
    residential_status?: string
    residential_years?: string
    residential_months?: string
    monthly_housing_payment?: string
    job_title?: string
    employment_status?: string
    employer_name?: string
    employer_years?: string
    employer_months?: string
    employer_monthly_gross?: string
    email_address?: string

    application_type?: string
    return_customer?: ReturnCustomerSelectionsType
    type?: string // Loan or Lease

    coapplicant_home_phone?: string
    coapplicant_mobile_phone?: string
    coapplicant_residential_status?: string
    coapplicant_residential_years?: string
    coapplicant_residential_months?: string
    coapplicant_monthly_housing_payment?: string
    coapplicant_job_title?: string
    coapplicant_employment_status?: string
    coapplicant_employer_name?: string
    coapplicant_employer_years?: string
    coapplicant_employer_months?: string
    coapplicant_employer_monthly_gross?: string
    coapplicant_email_address?: string

    customer_down_payment?: string
    customer_down_payment_override?: string
    financed_sales_tax?: number
    dealer_document_service_charge?: number
    dealer_title?: number
    dealer_freight?: number
    parts_and_labor?: number
    oem_accessories?: number
    other?: number
    oem_rebate?: number
    pre_paid_maintenance?: number
    tire_and_wheel?: number
    extended_service_plan?: number
    gap_insurance?: number
    trailer_sales_price?: number
    trade_in_allowance?: number
    trade_in_payoff?: number
    vehicle_asking_price?: number
    documentary_stamp_tax_amount?: number

    selected_tire_and_wheel?: SelectedTireAndWheel | null
    selected_extended_warranty?: SelectedExtendedWarranty | null
}

export default async function patchApplication(
    params: UpdateClientApplication | SubmitApplicationDTO,
    uuid: string,
    abortController?: AbortController,
) {
    try {
        const { data } = await axios.patch(
            `${config.API_BASE_URL}/api/v3/client-application/${uuid}/`,
            params,
            {
                signal: abortController?.signal,
                withCredentials: true,
            },
        )

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to update application: ${axiosError.message}`,
            axiosError,
            { applicationUuid: uuid },
        )

        throw new Error(axiosError.message)
    }
}
